import ThreeColumnMediaFull from '@/components/_rebrand/ThreeColumnMediaFull';
import { mapProps } from './ThreeBenefits.utils';

const ThreeBenefits = ({ entry }) => {
  const mappedProps = mapProps(entry);

  return (
    <ThreeColumnMediaFull {...mappedProps} />
  );
};

export default ThreeBenefits;
